import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSuperAdminAuth } from "../hooks/useSuperAdminAuth";

// SuperAdmin Layout
import SuperAdminLayout from "../components/superadmin/layout/SuperAdminLayout";

// SuperAdmin Pages
import SuperAdminLoginPage from "../pages/superadmin/LoginPage";
import SuperAdminDashboard from "../pages/superadmin/Dashboard";
import CompaniesListPage from "../pages/superadmin/CompaniesList";
import CompanyDetailPage from "../pages/superadmin/CompanyDetail";
import SuperAdminProfilePage from "../pages/superadmin/ProfilePage";
import CreateCompanyPage from "../pages/superadmin/CompanyCreate";
import EditCompanyPage from "../pages/superadmin/EditCompany";

const SuperAdminRoutes: React.FC = () => {
  const { isAuthenticated } = useSuperAdminAuth();

  return (
    <Routes>
      {/* Public Route - Login */}
      <Route
        path="/login"
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <SuperAdminLoginPage />
          )
        }
      />

      {/* Protected Routes - SuperAdmin Only */}
      {isAuthenticated ? (
        <Route element={<SuperAdminLayout />}>
          <Route path="/dashboard" element={<SuperAdminDashboard />} />
          <Route path="/profile" element={<SuperAdminProfilePage />} />
          <Route path="/companies" element={<CompaniesListPage />} />
          <Route path="/companies/create" element={<CreateCompanyPage />} />
          <Route path="/companies/:id/edit" element={<EditCompanyPage />} />
          <Route path="/companies/:id" element={<CompanyDetailPage />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      ) : (
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  );
};

export default SuperAdminRoutes;
